import { KYMW0D00Model } from './../kymw0d00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 処理ログ 処理結果ログ削除クラス
 *
 * @export DeleteLogProcessResultService
 * @class DeleteLogProcessResultService
 * @extends PlessJsonResponderSub
 */
@Injectable()
export class DeleteLogProcessResultService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW0D00Model;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteLogProcessResultService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        DispId: this.vo.dispId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof DeleteLogProcessResultService
   */
  execute(vo: any, successFunc: Function = null): void {
    this.vo = vo;
    this.send('deleteLogProcessResult', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteLogProcessResultService
   */
  success(data: any): void {
  }
}
